import { Autocomplete } from '@mui/material'
import React from 'react'
import { useAutoCompleteConfig } from './useAutoccompleteConfig'

export const BaseAutocomplete = <
  T,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
  ChipComponent extends React.ElementType = 'div',
>(
  props: React.ComponentProps<typeof Autocomplete<T, Multiple, DisableClearable, FreeSolo, ChipComponent>>
) => {
  const { makeDefaultNoOptionsText: makeNoOptionsText } = useAutoCompleteConfig()

  return (
    <Autocomplete<T, Multiple, DisableClearable, FreeSolo, ChipComponent>
      data-testid="base-autocomplete"
      noOptionsText={makeNoOptionsText(props.inputValue)}
      {...props}
    />
  )
}
